const swiper_US_Locale = {
    'swiper.banner1Title': 'Embracing a New Era',
    'swiper.banner1Title1':'of Intelligent Ultrasound',
    'swiper.banner1Conter1': 'Full-Stack Intelligent Ultrasound Solutions',
    'swiper.banner2Title': 'Integration and Innovation',
    'swiper.banner2Conter1': 'Deep coverage in multiple areas including reproductive/obstetrics/neonatology/',
    'swiper.banner2Conter2': 'gynecology/thyroid breast/new functionalities/and superficial organs',
    'swiper.banner3Title': 'Independently Developed',
    'swiper.banner3Title1': 'Core Algorithms',
    'swiper.banner3Conter1': 'Breaking Through the Limitations of Open Source Algorithms',
    'swiper.banner3Conter2': 'One of the earliest in China to deployment deep learning achievements to the intelligentization of ultrasound imaging',
    'swiper.banner4Title': 'Global Strategic Layout',
    'swiper.banner4Conter1': 'Embracing the Future of Ultrasound with AI on a Global Scale'
}
export default swiper_US_Locale
